/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-03-22 16:24:13
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-17 18:20:29
 */
let eventTemp = ""

let dealTemp = `function $dealData(data,self) {
// data 接口返回数据
// self 当前组件
}`

let initPageTemp = ""

//gis 依赖事件模板
let gisRelativeEventsTemp = {
  load: {
    relatives: [],
    fn: "",
  },
  click: {
    relatives: [],
    fn: "",
    hidden: true,
  },
  //区域点击事件
  districtClick: {
    relatives: [],
    fn: "",
  },
};
//事件中文名映射表
let eventKeyNames = {
  //公共组件事件
  click: "点击事件",
  change: "change事件",
  search: "搜索事件",
  clickCell: "单元格点击事件",
  dbclick: "双击事件",
  back: "返回事件",
  load: "加载完事件",
  more: "点击更多事件",
  check: "复选框事件",
  //gis 事件
  districtClick: "区域点击事件",
  //屏幕事件
  fullscreen: "全屏事件",
  noFullscreen: "退出全屏事件",


}
export {
  eventTemp,
  dealTemp,
  initPageTemp,
  gisRelativeEventsTemp,
  eventKeyNames
}